<template>
  <div class="application">
    <div class="headTitle">
      <div class="shadowTxt">JOIN US</div>
      <div class="title">我要应聘</div>
    </div>
    <div class="searchBox">
      <div class="search" @click="searchHandle">
        <span><img src="../../assets/images/search.png" alt="" /></span>
        <input
          type="text"
          placeholder="请输入职位关键字"
          v-model="search"
          @change="searchHandle"
        />
      </div>
      <div class="join-select">
        <!-- 社会招聘 -->
         <!-- <el-menu
          background-color="#E95506"
          text-color="#fff"
          >
          <el-submenu index="1">
            <template slot="title">
              <span>导航一</span>
            </template>
            <el-menu-item-group v-for="(item,index) in options" :key='index'>{{item.text}}</el-menu-item-group>
          </el-submenu>
        </el-menu> -->
        <b-form-select
          v-model="selected"
          :options="options"
          @change="change"
        ></b-form-select>
      </div>
    </div>
    <div class="jobBox">
      <p v-if="!lists">没有找到相关信息</p>
      <div
        class="jobPart"
        v-for="(item, index) in lists"
        :key="item.id"
        :index="index"
        @click="changeActiveId(item.id)"
        @changeActiveId="changeActiveId"
      >
        <div class="person">{{ item.position }}</div>
        <div class="place">{{ item.area }} ｜{{ item.location }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { apiGetOffers, apiGetOfferSearch } from "../../api/index";

export default {
  metaInfo: {
        title: '我要应聘-爱情地产',
        meta: [{
        name: 'keyWords',
        content: '爱情地产'
        },
        {
        name: 'description',
        content: ''
        }]
    },
  data() {
    return {
      search: "",
      selected: "2",
      options: [
        { value: "2", text: "校园招聘" },
        { value: "1", text: "社会招聘" },
      ],
      lists: [],
      activeId: 0,
    };
  },
  props: {
    item: Object,
    index: Number,
  },
  methods: {
    changeActiveId(id) {
      this.$emit("changeActiveId", id);
    },
    init() {
      apiGetOffers().then((data) => {
        if (data.data.status == 1) {
          this.lists = data.data.coffer;
          console.log(data.data.coffer);
        }
      });
    },
    change() {
      apiGetOfferSearch(this.selected, this.search).then((data) => {
        if (data.data.status == 1) {
          this.lists = data.data.coffer;
          console.log(data.data);
        }
      });
    },
    searchHandle() {
      apiGetOfferSearch(this.selected, this.search).then((data) => {
        if (data.data.status == 1) {
          this.lists = data.data.coffer;
        }
      });
    },
    changeActiveId(id) {
      this.activeId = id;
      this.$router.push({
        name: "applicateDetails",
        params: {
          id: id,
        },
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped lang='less'>
* {
  margin: 0;
  padding: 0;
}
img {
  width: 100%;
  display: flex;
}
.join-select {
  font-size: 13px;
  line-height: 18px;
  text-align: center;
  margin-right: 2px;
  background-color: #e95506;
  padding:12px 16px 13px 17px;
  border-radius: 5px;
  
  select {
    width: 70px;
    border: none;
    outline: none;
    color: #fff;
    // padding: 12px 4px 13px 17px;
    background-color: #e95506;
    border-radius: 5px;
    -webkit-appearance: none;
    background: url('../../assets/images/icon1.png') no-repeat;
    background-size: 10px 10px;
    background-position-x: 96%;
    background-position-y: 40%;
    /deep/option {
      color: #333;
    }
  }
}
.headTitle {
  padding: 20px 15px 7px 15px;
  background: #fff;
  .shadowTxt {
    font-size: 40px;
    line-height: 47px;
    color: #f8f8f8;
    font-family: "DIN Alternate Bold";
    font-weight: bold;
  }
  .title {
    color: #222;
    font-size: 18px;
    line-height: 25px;
    font-family: "苹方-简 中黑体";
    font-weight: 600;
    margin-top: -28px;
  }
}
.searchBox {
  padding: 0 20px 0 15px;
  display: flex;
  box-sizing: border-box;
  line-height: 43px;
  margin-top: 11px;
  .search {
    flex: 1;
    padding-left: 8px;
    background: #f8f8f8;
    span {
      width: 20px;
      height: 20px;
      display: inline-block;
      margin-right: 5px;
      vertical-align: top;
      margin-top: 11px;
      // border: 1px dotted #ccc;
      img {
        display: flex;
      }
    }
    input {
      width: 104px;
      font-size: 13px;
      line-height: 18px;
      color: #ccc;
      border: none;
      outline: none;
      vertical-align: top;
      margin-top: 12px;
      background: transparent;
    }
  }
  .recruit {
    font-size: 13px;
    line-height: 18px;
    background: #e95506;
    border-radius: 5px;
    padding: 12px 16px 13px 17px;
    color: #fff;
    font-weight: 500;
    span {
      width: 10px;
      height: 10px;
      margin-left: 4px;
      display: inline-block;
    }
  }
}
.jobBox {
  padding: 0 15px;
  p{
    font-size: 16px;
  }
  .jobPart {
    padding: 20px 0;
    border-bottom: 1px solid #efefef;
    .person {
      color: #333;
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 10px;
      font-weight: 500;
    }
    .place {
      font-size: 12px;
      line-height: 17px;
      color: #666666;
    }
  }
}
</style>